import React from 'react'

import styles from './Actions.module.scss'

const Actions = ({ children }) => <ul className={styles.actions}>{children}</ul>

export default Actions
